import { Component, Prop, Ref, log, useProp } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class ContactMain extends ThemeComponent {
    @Ref() submit!: HTMLButtonElement;
    @Ref() inputs!: HTMLElement[];
    @Ref() form!: HTMLFormElement;

    init() {
        this.checkForm();
        for (const input of this.inputs) {
            this.$listen(input, 'change', () => this.checkForm());
            this.$listen(input, 'keyup', () => this.checkForm());
        }
    }
    checkForm() {
        const formValid = this.form.checkValidity();
        if (formValid) {
            this.submit.removeAttribute('disabled');
            this.submit.classList.remove('button--disabled');
        } else {
            this.submit.setAttribute('disabled', '');
            this.submit.classList.add('button--disabled');
        }
    }
}
